import {createContext} from 'react';

// The public review site has no app introduction. The embedded game supplies
// this callback only inside its existing expandable rules.
export const CitizenScienceIntroductionContext = createContext(null);
